import { BBadge } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBBadge when migrating. */
export const EgBBadge = createEgBootstrapProxy("EgBBadge", BBadge);
